export default "__VITE_ASSET__aj90hVBG__"